import React, { useRef } from "react";
import SkeletonTable from "../Skeleton/SkeletonTable";
import { buildName } from "helper/tools";
import ProgressRing from "../ProgressRing/ProgressRing";

export default function AsociadosKPITableSmall({
  items,
  openItem,
  handleSortChange,
  isLoading = false,
}) {
  const theadRef = useRef();

  function handleSort(event) {
    //data-order="desc"

    // Reference to the clicked header element
    const header = event.target;
    // Get the column to sort by from the data attribute
    const column = header.getAttribute("data-column");
    // Get the current sort order (asc or desc) from the data attribute
    const order = header.getAttribute("data-order");

    if (column?.length === 0) {
      return;
    }

    // Determine the new sort order by toggling the current order
    const newOrder = order === "desc" ? "asc" : "desc";
    // Update the data-order attribute with the new sort order
    header.setAttribute("data-order", newOrder);

    const value = event.target;

    console.log(value);

    console.log(theadRef);

    /** */
    const children = theadRef.current.children;
    for (let element of children) {
      element.classList.remove("dir-d", "dir-u");
      if (element === value) {
        const newOrderClass = newOrder === "desc" ? "dir-d" : "dir-u";
        element.classList.add(newOrderClass);
      }
    }

    handleSortChange({
      sortBy: column,
      sortAsc: newOrder,
    });
  }

  return (
    <table
      className="table table-borderless datable sortable table-hover"
      style={{ tableLayout: "fixed" }}
    >
      <thead className="table-light" style={{ textAlign: "center" }}>
        <tr ref={theadRef}>
          <th
            rowSpan={2}
            scope="col"
            data-column="asociado.id"
            style={{ width: "90px", verticalAlign: "middle" }}
            onClick={(event) => handleSort(event)}
          >
            Id
          </th>
          <th
            rowSpan={2}
            scope="col"
            data-column="asociado.nombre"
            style={{ verticalAlign: "middle", width: "99%" }}
            onClick={(event) => handleSort(event)}
          >
            Nombre
          </th>

          <th
            rowSpan={2}
            scope="col"
            data-column="sum"
            onClick={(event) => handleSort(event)}
            style={{ width: "120px", verticalAlign: "middle" }}
          >
            Calidad de Información
          </th>
        </tr>
      </thead>
      <tbody>
        {isLoading && (
          <div className="animate-pulse">
            <div></div>
          </div>
        )}

        {!isLoading &&
          items?.length > 0 &&
          items?.map((data, index) => {
            const { sum, asociado } = data;
            const item = asociado;
            const nombre = buildName(item, true);

            return (
              <tr key={item.id}>
                <th
                  scope="row"
                  style={{
                    verticalAlign: "middle",
                    justifyItems: "center",
                    textAlign: "center",
                  }}
                >
                  <a href="#" onClick={(e) => openItem(item)}>
                    {item.numAsociado ?? ""}
                  </a>
                </th>
                <td>
                  <a
                    href="#"
                    className="text-primary"
                    onClick={(e) => openItem(item)}
                  >
                    {nombre}
                  </a>
                </td>

                <td style={{ justifyContent: "center", display: "flex" }}>
                  <ProgressRing
                    radiusProp={25}
                    strokeProp={6}
                    strokeColor={"red"}
                    progress={sum}
                  />
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
}
